import { render, staticRenderFns } from "./expense-payment-export.vue?vue&type=template&id=5627a4a8&"
import script from "./expense-payment-export.vue?vue&type=script&lang=js&"
export * from "./expense-payment-export.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports